<template>
  <div
    class="rate-limit-counter-banner-component"
    @click="$emit('click')"
  >
    <div
      v-if="creditsAvailable > 0"
      class="label"
    >
      Today's Free Questions
    </div>
    <button
      v-else
      class="start-free-trial-button"
    >
      Start Free Trial
    </button>
    <div class="notches">
      <div
        v-for="index in totalCreditsAvailable"
        :key="index"
        class="notch"
        :class="{ used: index <= creditsUsed }"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RateLimitCounterBanner',
  props: {
    creditsUsed: {
      type: Number,
      default: 0,
    },
    totalCreditsAvailable: {
      type: Number,
      default: 0,
    },
  },
  emits: ['click'],
  computed: {
    creditsAvailable() {
      return this.totalCreditsAvailable - this.creditsUsed;
    },
  },
};
</script>

<style lang='scss' scoped>
.rate-limit-counter-banner-component {
  background-color: #FFD83E;
  color: rgba(0, 0, 0, 0.8);
  font-size: rem-calc(10);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: rem-calc(7);
  max-height: rem-calc(22);
  gap: rem-calc(16);
  cursor: pointer;
}

.notches {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: rem-calc(4);

  .notch {
    width: rem-calc(24);
    height: rem-calc(6);
    border-radius: rem-calc(3);
    background-color: #000000;
    opacity: 0.35;

    &.used {
      opacity: 0.65;
    }
  }
}

.label {
  line-height: rem-calc(22);
  font-weight: bold;
}

.start-free-trial-button {
  background: rgba(255, 255, 255, 0.35);
  border: 1px solid rgba(0, 0, 0, 0.5);
  line-height: rem-calc(18);
  border-radius: rem-calc(18);
  font-weight: bold;
}

@media screen and (max-width: 460px) {
  .notches {
    gap: rem-calc(2);

    .notch {
      width: 5vw;
    }
  }
}
</style>
